(() => {
  if (window.__laganiniLocalization) return;
  window.__laganiniLocalization = true;
  const root = document.documentElement;
  let returnFocus;
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  const closeLanguages = (except) => {
    document.querySelectorAll('[data-language-disclosure][open]').forEach((item) => {
      if (item !== except) item.open = false;
    });
  };
  const filterCountries = (dialog) => {
    const query = normalize(dialog.querySelector('[data-market-search]').value);
    let visible = 0;
    dialog.querySelectorAll('[data-market-continent]').forEach((group) => {
      let groupVisible = 0;
      group.querySelectorAll('[data-market-country]').forEach((item) => {
        const button = item.querySelector('button');
        item.hidden = !normalize(`${item.textContent} ${button.value} ${group.dataset.marketContinentName}`).includes(query);
        if (!item.hidden) groupVisible++;
      });
      group.hidden = groupVisible === 0;
      group.querySelector('[data-market-count]').textContent = groupVisible;
      const link = dialog.querySelector(`[data-market-continent-link="${group.dataset.marketContinent}"]`);
      if (link) link.hidden = group.hidden;
      visible += groupVisible;
    });
    dialog.querySelector('[data-market-empty]').hidden = visible > 0;
  };
  document.addEventListener('click', (event) => {
    const languageButton = event.target.closest('button[name="language_code"]');
    if (languageButton) {
      try { localStorage.setItem('lg-language-choice', `${languageButton.value}:${window.Shopify?.country || ''}`); } catch (e) {}
    }
    const disclosure = event.target.closest('[data-language-disclosure]');
    closeLanguages(disclosure);
    const trigger = event.target.closest('[data-market-open]');
    if (trigger) {
      const dialog = document.querySelector('[data-market-dialog]');
      if (!dialog) return;
      returnFocus = trigger;
      dialog.querySelector('[data-market-search]').value = '';
      filterCountries(dialog);
      dialog.showModal();
      dialog.querySelector('.lg-market__body').scrollTop = 0;
      root.classList.add('lg-market-open');
    }
    const continentLink = event.target.closest('[data-market-continent-link]');
    if (continentLink) {
      event.preventDefault();
      const group = document.getElementById(continentLink.hash.slice(1));
      if (group) {
        group.scrollIntoView({ block: 'start' });
        group.querySelector('button')?.focus({ preventScroll: true });
      }
    }
    if (event.target.closest('[data-market-close]')) {
      event.target.closest('[data-market-dialog]').close();
    }
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-market-search]')) filterCountries(event.target.closest('[data-market-dialog]'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('[data-market-dialog][open]');
    if (dialog) {
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.close();
      return;
    }
    const disclosure = document.querySelector('[data-language-disclosure][open]');
    if (disclosure) {
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('close', (event) => {
    if (!event.target.matches('[data-market-dialog]')) return;
    root.classList.remove('lg-market-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  }, true);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-market-dialog]')) root.classList.remove('lg-market-open');
  });
})();
